import { ActionTypes } from "./action-types";
import { IAppState, IPortalOpo, unloadedState } from "./state";
import { IUser, ICenter, ICenterMetrics } from "../../models/index";
import { DisplayType, OrganType } from "../../enums/index";

interface IToggleMenu {
    type: string,
    menuVisible: boolean
}

interface IToggleLoading {
    type: string,
    showLoading: boolean,
    message: string
}

interface IChangeDisplay {
    type: string,
    display: DisplayType
}

interface ISetUserProfile {
    type: string,
    user: IUser
}

interface IShowAlert {
    title: string,
    message: string | JSX.Element
}

interface ISetCenter {
    type: string,
    center: ICenter
}

interface IHideAlert { }

interface ISetCenterMetrics {
    type: string,
    data: ICenterMetrics
}

interface ISetSite {
    type: string,
    payload: {
        domain: string,
        organ: string,
        organType: OrganType
    }
}

interface ISetOpo {
    type: string,
    opo: IPortalOpo | null
}

const toggleMenu =(state: IAppState, action: IToggleMenu) => {
    state.menuVisible = !state.menuVisible;
    return state;
}

const toggleLoading = (state: IAppState, action: IToggleLoading) => {
    state.loading = action.showLoading;
    state.loadingMessage = action.message;
    return state;
}

const setUserProfile = (state: IAppState, action: ISetUserProfile) => {
    state.user = action.user;
    return state;
}

const showAlert = (state: IAppState, action: IShowAlert) => {
    state.alert = {
        show: true,
        title: action.title,
        message: action.message
    };

    return state;
}

const hideAlert = (state: IAppState, action: IHideAlert) => {
    state.alert = {
        show: false,
        title: "",
        message: ""
    };

    return state;
}

const changeDisplay = (state: IAppState, action: IChangeDisplay) => {
    state.display = action.display;
    return state;
}

const setCenter = (state: IAppState, action: ISetCenter) => {
    state.center = action.center;
    return state;
}

const setCenterMetrics = (state: IAppState, action: ISetCenterMetrics) => {
    state.centerMetrics = action.data;
    return state;
}

const setSite = (state: IAppState, action: ISetSite) => {
    state.site = action.payload
    return state;
}

const setOpo = (state: IAppState, action: ISetOpo) => {
    state.opo = action.opo;
    return state;
}

const createReducer =(initialState: IAppState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
    [ActionTypes.TOGGLE_MENU]: toggleMenu,
    [ActionTypes.TOGGLE_LOADING]: toggleLoading,
    [ActionTypes.SET_USER_PROFILE]: setUserProfile,
    [ActionTypes.SHOW_ALERT]: showAlert,
    [ActionTypes.HIDE_ALERT]: hideAlert,
    [ActionTypes.CHANGE_DISPLAY]: changeDisplay,
    [ActionTypes.SET_CENTER]: setCenter,
    [ActionTypes.SET_CENTER_METRICS]: setCenterMetrics,
    [ActionTypes.SET_SITE]: setSite,
    [ActionTypes.SET_OPO]: setOpo
};

export const Reducer = createReducer(unloadedState, handlers);
